export const alarmStatus = ['droplet', 'TEMPERATURE', 'STACJA'];
